module.exports = __webpack_public_path__ + "img/icon-menu-alt.c34d8e7f.svg";